import ViewType from 'constants/productViewType';
import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './types';
import { IDataItems } from 'services/api/category';
import {
  FiltersSelectionInitialValue,
  IFiltersSelection,
} from 'components/molecules/ProductFilter/store/reducer';
import { PropertyFilterType } from 'components/molecules/ProductFilter/configuration';
import { isObjectNullish } from 'utils/objects';
import {
  DataItemParalist,
  ICollectionOutput,
  IProductListOutput,
} from 'services/api/product';
import * as PointofinterestServices from 'services/api/pointofinterest';
import {
  IFavoritesData,
  IClientCollectionsData,
  ICustomersMiniProfileData,
} from 'services/api/client';
import * as ProductService from 'services/api/product';
import { IFetchGoogleSearchPlaceOutput } from 'services/api/google';
import * as PointOfInterestCategoryServices from 'services/api/pointofinterestcategory';
import _ from 'lodash';

export interface IState {
  sendMail: {
    status: StateStatus | null;
    data: any;
  };
  sendMailAdvance: {
    status: StateStatus | null;
    data: any;
  };
  clientMiniProfiles: {
    status: StateStatus | null;
    data: ICustomersMiniProfileData | null;
  };
  documents: {
    status: StateStatus | null;
    data: Array<any>;
  };
}

export const initialState: IState = {
  sendMail: {
    status: null,
    data: null,
  },
  sendMailAdvance: {
    status: null,
    data: null,
  },
  clientMiniProfiles: {
    status: null,
    data: null,
  },
  documents: {
    status: null,
    data: [],
  },
};

const SendMailReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SEND_EMAIL_PRODUCT:
      return {
        ...state,
        sendMail: {
          data: action.data,
          status: action.status || null,
        },
      };
    case Types.SEND_EMAIL_ADVANCE_PRODUCT:
      return {
        ...state,
        sendMailAdvance: {
          data: action.data,
          status: action.status || null,
        },
      };

    case Types.SET_CLIENTS_MINI_PROFILES:
      return {
        ...state,
        clientMiniProfiles: {
          ...state.clientMiniProfiles,
          status: action.status || null,
          data: action.data,
        },
      };

    case Types.SET_PRODUCT_DOCUMENT:
      return {
        ...state,
        documents: {
          ...state.documents,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? [...state.documents.data]
              : _.uniqBy(
                  [...state.documents.data, ...action.data],
                  (item) => item?.['id']
                ),
        },
      };
    case Types.RESET_DOCUMENT:
      return {
        ...state,
        documents: {
          status: null,
          data: [],
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default SendMailReducer;
